import FormStyled, { FormItemStyled, FormHeaderStyled } from "./form.styles";

const { Item } = FormStyled;

export { Item, FormStyled, FormItemStyled, FormHeaderStyled };
